import { Injectable } from "@angular/core";
import { CategoryChoice, ServiceItem, TaskType } from "../model/model";

@Injectable({
  providedIn: "root"
})
export class ServiceItemService {
  serviceItems: ServiceItem[] = [];

  constructor() {
    this.serviceItems.push(new ServiceItem(
      1,
      CategoryChoice.TEXT,
      "Traducción de textos",
      "Traduce textos desde el Español al Inglés usando el modelo opus-mt-es-en.",
      `
Traduce textos desde el Español al Inglés usando el modelo opus-mt-es-en.

Basado en el modelo <u>[MarianMT](https://marian-nmt.github.io/)</u>.

El modelo fue originalmente entrenado usando el dataset <u>[Open Parallel Corpus(OPUS)](http://opus.nlpl.eu/)</u> por <u>[Jörg Tiedemann](https://researchportal.helsinki.fi/en/persons/j%C3%B6rg-tiedemann)</u> usando la biblioteca de C++ Marian, la cual permite entrenamientos y traducciones rápidas.

### **Importante**

Dado que el servicio está detenido después de un tiempo de inactividad, puede recibir diferentes respuestas
cuando es invocado estando inactivo. Estas respuestas le informaran sobre el estado en el que se encuentra,
el cual puede tomar valores como *stopped*, *pending* y *starting*.

Vea el siguiente ejemplo:
~~~json
{
  "outputs": {
    "info": "Service instance is not running yet",
    "state": "pending"
  }
}
~~~`,
      "http://compai-admin-backend.onrender.com/api/model/opus-mt-es-en",
      3,
      TaskType.TRANSLATION,
      `curl
-X POST http://compai-admin-backend.onrender.com/api/model/opus-mt-es-en
-d '{
  "inputs": {
    "text": "En el mundo de los servicios resulta necesario que el cliente se sienta que es importante y se le escucha. \nCada cual tiene sus fortalezas."
  },
  "token": "<TOKEN>"
}'

// Respuesta de ejemplo
{
  "outputs": {
    "result": [
      {
        "translation_text": "In the world of services it is necessary for the customer to feel that it is important and to be heard. \nEveryone has their strengths."
      }
    ]
  }
}`
    ));

    // Pendiente
//     this.serviceItems.push(new ServiceItem(
//       2,
//       CategoryChoice.TEXT,
//       "Preguntas y respuestas",
//       "Defina un texto deseado y comience a realizar preguntas sobre el mismo.",
//       "**BETO (BERT Español) + SQuAD2.0 Español + destilación usando 'bert-base-multilingual-cased' como maestro.** \
//       \n\nEste modelo es un afinación sobre <u>[SQuAD-es-v2.0](https://github.com/ccasimiro88/TranslateAlignRetrieve)</u> y una versión destilada de BETO para preguntas y respuestas. \
//       La destilación hace que el modelos sea más pequeño, rápido, barato y ligero, comparado con bert-base-spanish-wwm-cased-finetuned-spa-squad2-es. \
//       \n\nEste modelo fue afinado usando el mismo conjunto de datos pero aplicando la técnica de destilación durante el proceso de afinación y sobre una iteración de entrenamiento. \
//       \n\nEl modelo usado como maestro para la destilacion fue bert-base-multilingual-cased. Es el mismo usado para la creación de distilbert-base-multilingual-cased AKA DistilmBERT (es en promedio, tan rápido como mBERT-base).",
//       "http://localhost:8000/api/model/distill-bert-base-spanish-wwm-cased-finetuned-spa-squad2-es",
//       3,
//       TaskType.QNA,
//       `curl
// -d '{
//   "token":"<TOKEN>",
//   "inputs": {
//     "context":"Los pisáuridos (Pisauridae) son una familia de arañas araneomorfas que engloba a unas 550 especies, \ndistribuidas por todo el mundo. Viven en el suelo, en la superficie de aguas estancadas y en plantas acuáticas. Son arañas grandes \nque se parecen a las arañas lobo (Lycosidae) en la forma que tienen de cazar y atrapar a la presa. Su caparazón es ovalado \ncon marcas longitudinales. Las hembras llevan las ootecas en los quelíceros, que cuelgan bajo su cuerpo. Las crías recién nacidas \nson colocadas en unas telarañas con forma de carpa, donde son cuidadas hasta la segunda muda de piel.",
//     "question":"¿Cómo es el caparazón de las arañas?"
//   }
// }'
// -X POST http://localhost:8000/api/model/distill-bert-base-spanish-wwm-cased-finetuned-spa-squad2-es

// // Respuesta de ejemplo
// {
//   "outputs": {
//     "result": {
//       "score": 0.6880430579185486,
//       "start": 346,
//       "end": 353,
//       "answer": "ovalado"
//     }
//   }
// }`
//     ));

    // Pendiente
//     this.serviceItems.push(new ServiceItem(
//       3,
//       CategoryChoice.TEXT,
//       "Análisis de sentimientos",
//       "Obtenga una valoración de 1 a 5 respecto a cuan positivo es un texto.",
//       "Este es un modelo basado en BERT multilenguaje, afinado para el análisis de sentimientos dando una valoración de 1 a 5 en seis idiomas: Inglés, Holandés, Alemán, Francés, Español e Italiano.",
//       "http://localhost:8000/api/model/bert-base-multilingual-uncased-sentiment",
//       3,
//       TaskType.TEXT_CLASS,
//       `curl
// -d '{
//   "token":"<TOKEN>",
//   "inputs": {
//     "text":"Si tuviera que definir película En un barrio de Nueva York con pocas palabras, diría que es una cinta que derrocha \nalegría y vida con cada fotograma. Un sentimiento que contagia al espectador, que cautiva, que hipnotiza. Ya sea por sus \ncomplicados números musicales o por el elenco perfectamente escogido, la cinta es una gran adaptación del musical de Broadway \nque llega pisando fuerte a las salas de cine."
//   }
// }'
// -X POST http://localhost:8000/api/model/bert-base-multilingual-uncased-sentiment

// // Respuesta de ejemplo
// {
//   "outputs": {
//     "result": [
//       {"label": "5 stars", "score": 0.3344813883304596}
//     ]
//   }
// }`
//     ));

    // Pendiente
//     this.serviceItems.push(new ServiceItem(
//       4,
//       CategoryChoice.TEXT,
//       "Clasificación Zero-Shot",
//       "Clasifica el dominio de un texto a partir de las clases dinámicas definidas por usted.",
//       "Este modelo es una versión afinada del modelo BERT usando la porción en Español del dataset <u>[XNLI](https://github.com/facebookresearch/XNLI)</u>. \
//       \n\nLa precisión alcanzada sobre el conjunto de prueba de XNLI-es es de 79.9%.",
//       "http://localhost:8000/api/model/bert-base-spanish-wwm-cased-xnli",
//       3,
//       TaskType.ZERO_SHOT_CLASS,
//       `curl
//   -d '{
//     "token":"<TOKEN>",
//     "inputs": {
//       "text":"Los peloteros hicieron un buen desempeño durante la temporada",
//       "candidates":["cultura", "política", "deporte", "ciencia"],
//       "hypothesis":"El texto es sobre {}"
//     }
//   }'
//   -X POST http://localhost:8000/api/model/bert-base-spanish-wwm-cased-xnli

// // Respuesta de ejemplo
// {
//   "outputs": {
//     "result": {
//       "sequence": "Los peloteros hicieron un buen desempeño durante la temporada",
//       "labels": ["deporte", "cultura", "política", "ciencia"],
//       "scores": [0.6650740504264832, 0.2105804979801178, 0.07020796090364456, 0.054137419909238815]
//     }
//   }
// }`
//     ));

    // Pendiente
//     this.serviceItems.push(new ServiceItem(
//       5,
//       CategoryChoice.TEXT,
//       "Generación de texto con GPT-2",
//       "Modelo de lenguaje para Español basado en GPT-2.",
//       `Modelo de lenguaje para Español basado en GPT-2.

//       \nFué entrenado con la Wikipedia en Español usando técnicas de Aprendizaje por Transferencia y afinación de modelos. El entrenamiento del modelo tomó alrededor 70 horas con cuatro GPUs NVIDIA GTX 1080-Ti con 11GB de DDR5 y con aproximadamente 3GB de datos de entrenamiento preprocesados.

//       \nFue afinado del modelo en Inglés English pre-trained GPT-2 small utilizando las librerías de Hugging Face (Transformers y Tokenizers) integradas con el framework de Deep Learning <u>[fastai v2](https://dev.fast.ai/)</u>. Se usaron técnicas de afinamiento fino de fastai v2.

//       \nEl entrenamiento está enteramente basado en el modelo en Portugués GPorTuguese-2 desarrollado por Pierre Guillou. Los detalles del entrenamiento se encuentran en este articulo: <u>["Faster than training from scratch — Fine-tuning the English GPT-2 in any language with Hugging Face and fastai v2 (practical case with Portuguese)"](https://medium.com/@pierre_guillou/faster-than-training-from-scratch-fine-tuning-the-english-gpt-2-in-any-language-with-hugging-f2ec05c98787)</u>.`,
//       "http://localhost:8000/api/model/gpt2-small-spanish",
//       3,
//       TaskType.TEXT_GEN,
//       `curl
//   -d '{
//     "token":"<TOKEN>",
//     "inputs": {
//       "text":"Los peloteros hicieron un buen desempeño durante la temporada"
//     }
//   }'
//   -X POST http://localhost:8000/api/model/gpt2-small-spanish

// // Respuesta de ejemplo
// {
//   "outputs": {
//     "result": [
//       {
//         "generated_text": "Los peloteros hicieron un buen desempeño durante la temporada 2008, pero perdieron la categoría. \nEn la temporada 2009 comenzaron a trabajar en su nuevo equipo."
//       }
//     ]
//   }
// }`
//     ));

    // Pendiente
//     this.serviceItems.push(new ServiceItem(
//       6,
//       CategoryChoice.TEXT,
//       "Completar máscara",
//       "Ofrece variantes de palabras para ser ubicadas en la sección de la oración definida como máscara.",
//       `RuPERTa-base (uncased) es un <u>[modelo RoBERTa](https://github.com/pytorch/fairseq/tree/master/examples/roberta)</u> entrenado en la versión uncased de un <u>[corpus Español](https://github.com/josecannete/spanish-corpora)</u>.

//       \nRoBERTa itera sobre el procedimiento de pre-entrenamiento de BERT, incluyendo un entrenamiento por más tiempo, con mayor valor para los batch; eliminando el objetivo de predicción de la próxima oración.

//       \nEl mismo fue entrenado sobre secuencias más largas y cambiando dinámicamente el patrón de máscara aplicado a los datos de entrenamiento. La arquitectura es la misma de roberta-base con 125M de parámetros.`,
//       "http://localhost:8000/api/model/RuPERTa-base",
//       3,
//       TaskType.FILL_MASK,
//       `curl
//   -d '{
//     "token":"<TOKEN>",
//     "inputs": {
//       "text":"Los peloteros hicieron un buen desempeño durante la <mask>"
//     }
//   }'
//   -X POST http://localhost:8000/api/model/RuPERTa-base

// // Respuesta de ejemplo
// {
//   "outputs": {
//     "result": [
//       {
//         "sequence": "Los peloteros hicieron un buen desempe\u00f1o durante la guerra",
//         "score": 0.06761107593774796,
//         "token": 2179,
//         "token_str": " guerra"
//       },
//       {
//         "sequence": "Los peloteros hicieron un buen desempe\u00f1o durante la noche",
//         "score": 0.035740770399570465,
//         "token": 1374,
//         "token_str": " noche"
//       },
//       {
//         "sequence": "Los peloteros hicieron un buen desempe\u00f1o durante la ma\u00f1ana",
//         "score": 0.02936002053320408,
//         "token": 1882,
//         "token_str": " ma\u00f1ana"
//       },
//       {
//         "sequence": "Los peloteros hicieron un buen desempe\u00f1o durante la vida",
//         "score": 0.029251636937260628,
//         "token": 937,
//         "token_str": " vida"},
//       {
//         "sequence": "Los peloteros hicieron un buen desempe\u00f1o durante la historia",
//         "score": 0.022460563108325005,
//         "token": 1944,
//         "token_str": " historia"
//       }
//     ]
//   }
// }`
//     ));

    // Pendiente
//     this.serviceItems.push(new ServiceItem(
//       7,
//       CategoryChoice.TEXT,
//       "Reconocimiento de entidades",
//       "Reconoce entidades en el texto tales como Persona, Organización, Lugar, Compañías, etc.",
//       `RuPERTa-base (uncased) es un <u>[modelo RoBERTa](https://github.com/pytorch/fairseq/tree/master/examples/roberta)</u> entrenado en la versión uncased de un <u>[corpus Español](https://github.com/josecannete/spanish-corpora)</u>.

//       \nRoBERTa itera sobre el procedimiento de pre-entrenamiento de BERT, incluyendo un entrenamiento por más tiempo, con mayor valor para los batch; eliminando el objetivo de predicción de la próxima oración.

//       \nEl mismo fue entrenado sobre secuencias más largas y cambiando dinámicamente el patrón de máscara aplicado a los datos de entrenamiento. La arquitectura es la misma de roberta-base con 125M de parámetros.`,
//       "http://localhost:8000/api/model/RuPERTa-base-finetuned-ner",
//       3,
//       TaskType.TOKEN_CLASS,
//       `curl
// -d '{
//   "token":"<TOKEN>",
//   "inputs": {
//     "text":"Los peloteros hicieron un buen desempeño durante el juego realizado en Cuba"
//   }
// }'
// -X POST http://localhost:8000/api/model/RuPERTa-base-finetuned-ner

// // Respuesta de ejemplo
// {
//   "outputs": {
//     "result":
//     "Los: B-ORG
//     peloteros: O
//     hicieron: O
//     un: O
//     buen: O
//     desempe\u00f1o: O
//     durante: O
//     el: O
//     juego: O
//     realizado: O
//     en: O
//     Cuba: O"
//   }
// }`
//     ));

    // Pendiente
//     this.serviceItems.push(new ServiceItem(
//       8,
//       CategoryChoice.TEXT,
//       "Resumen de textos",
//       "Resumen de documentos o artículos de idioma Español en textos más cortos.",
//       `Resumen de documentos o artículos de idioma Español en textos más cortos usando Bert2Bert (BETO).

//       \nBETO fue afinado usando el conjunto de datos <u>[MLSUM](https://github.com/recitalAI/MLSUM)</u> (MultiLingual SUMmarization). MLSUM es el primer conjunto de datos de resumen multilingüe a gran escala. Obtenido de periódicos en línea, contiene más de 1,5 millones de pares de artículos / resúmenes en cinco idiomas diferentes: francés, alemán, español, ruso y turco. Junto con los periódicos en inglés del popular conjunto de datos de CNN / Daily mail, los datos recopilados forman un conjunto de datos multilingüe a gran escala que puede permitir nuevas direcciones de investigación para la comunidad de resumen de texto. Reportamos análisis comparativos entre idiomas basados en sistemas de última generación. Estos destacan los sesgos existentes que motivan el uso de un conjunto de datos multilingüe.

//       \nDescripción de los datos usados para el afinamiento:

//       \n<table style="width:100%">
//       <tr>
//         <th>Idioma&nbsp&nbsp</th>
//         <th>Entrenamiento&nbsp&nbsp</th>
//         <th>Validación&nbsp&nbsp</th>
//         <th>Prueba</th>
//       </tr>
//       <tr>
//         <td>de</td>
//         <td>220887</td>
//         <td>11394</td>
//         <td>10701</td>
//       </tr>
//       <tr>
//         <td>es</td>
//         <td>266367</td>
//         <td>10358</td>
//         <td>13920</td>
//       </tr>
//       <tr>
//         <td>fr</td>
//         <td>392902</td>
//         <td>16059</td>
//         <td>15828</td>
//       </tr>
//       <tr>
//         <td>ru</td>
//         <td>25556</td>
//         <td>750</td>
//         <td>757</td>
//       </tr>
//       <tr>
//         <td>tu</td>
//         <td>249277</td>
//         <td>11565</td>
//         <td>12775</td>
//       </tr>
//     </table>`,
//       "http://localhost:8000/api/model/bert2bert_shared-spanish-finetuned-summarization",
//       3,
//       TaskType.SUMMARY,
//       `curl
// -d '{
//   "token":"<TOKEN>",
//   "inputs": {
//     "text":"Al filo de las 22.00 horas del jueves, la Asamblea de Madrid vive un momento sorprendente: Vox decide no apoyar una \npropuesta del PP en favor del blindaje fiscal de la Comunidad. Se ha roto la unidad de los tres partidos de derechas. Es un hecho excepcional. \nDesde que arrancó la legislatura, PP, Cs y Vox han votado en bloque casi el 75% de las veces en el pleno de la Cámara. Juntos decidieron la composición de la Mesa de la Asamblea. \nJuntos invistieron presidenta a Isabel Díaz Ayuso. Y juntos han votado la mayoría de proposiciones no de ley, incluida la que ha marcado el \nesprint final de la campaña para las elecciones generales: acaban de instar al Gobierno de España a 'la ilegalización inmediata' de los \npartidos separatistas 'que atenten contra la unidad de la Nación'. Los críticos de Cs no comparten el apoyo al texto de Vox contra el \nsecesionisimo Ese balance retrata una necesidad antes que una complicidad, según fuentes del PP con predicamento en la dirección \nregional y nacional. Tras casi 15 años gobernando con mayoría absoluta, la formación conservadora vivió como una tortura la pasada \nlegislatura, en la que dependió de Cs para sacar adelante sus iniciativas. El problema se agudizó tras las elecciones autonómicas de mayo. \nEl PP ha tenido que formar con Cs el primer gobierno de coalición de la historia de la región, y ni siquiera con eso le basta para ganar las \nvotaciones de la Cámara. Los dos socios gubernamentales necesitan a Vox, la menos predecible de las tres formaciones."
//   }
// }'
// -X POST http://localhost:8000/api/model/bert2bert_shared-spanish-finetuned-summarization

// // Respuesta de ejemplo
// {
//   "outputs": {
//     "result": [
//       {
//         "summary_text": "El PP, Cs y Vox votaron en bloque casi el 75 % de las veces en el pleno de la Cámara"
//       }
//     ]
//   }
// }`
//     ));

    this.serviceItems.push(new ServiceItem(
      9,
      CategoryChoice.TEXT,
      "Reconocimiento de entidades en currículos",
      "Reconocimiento de entidades tales como tecnologías, certificaciones, nombres, direcciones, etc.",
      `El modelo es capaz de reconocer en currículos escritos en Inglés, entidades tales como: Direcciones, Certificaciones, Nombres de colegios, Compañías, Designaciones, Educación, Correos, Experiencia, Enlaces, Ubicaciones, Nombres, Teléfonos, Proyectos, Premios, Habilidades y Tecnologías.
      \nFue entrenado con 120 currículos usando como base la arquitectura ofrecida por <i>[spaCy](https://spacy.io/)</i> para la detección de entidades.
      `,
      "http://compai-admin-backend.onrender.com/api/model/spacy-ner-resume",
      3,
      TaskType.TOKEN_CLASS,
      `curl
  -d '{
  "token":"<TOKEN>",
  "inputs": {
    "text":"RESUME  Julian Casal, Havana 203918 juliancasal109@gmail.com +53 53817446  To be a part of a challenging environment that enhances my skills, through which I would like to enrich the knowledge resource of the company \nand work towards its success.  EXPERIENCE  SKILLS  Openspace Services Pvt. Ltd., havana-Python Developer JAN 2020 - PRESENT Working on Computer Vision and Natural Language Processing using Deep Neural Network.  \nINTERNSHIPS  Openspace Services Pvt. Ltd., Havana-Python Developer - Intern DEC 2019 - DEC 2020 Worked on rule based text extraction, tesseract, classification model using Convolution Neural Network.  Dongre Technoquip Pvt. \nLtd., Havana  Software Engineer - PHP(Intern) JUN 2019 - NOV 2019 Worked designing and optimizing the database of CRM for Bootcamp and the core product of the company.  EDUCATION  Government Engineering College, Havana  BE \nComputer Science JUN 2016 - JUN 2020 CGPA : 8.29/10  Technologies : Python, MySQL  Theory : Neural Network, Computer Vision, Vector Algebra, Classification and regression ML algorithms  Library : OpenCV, Tensorflow2.0, \nHugging Face NLP, Scikit-Learn, Keras  ACHIEVEMENTS  Grand Finalist of Smart Cuba Hackathon 2017  Grand Finalist of Smart City Holguín Hackathon 2017  VOLUNTEERSHIP  National Service Scheme(2017-2019)  LANGUAGES  \nEnglish, Spanish  WORK SAMPLE  juliancasal109 (Julian Casal)  GitHub      CERTIFICATIONS  Python for Data Science and AI by IBM (Online Coursera)  Machine Learning by Andrew Ng (Online Coursera Stanford University)   9/\n10  PROJECTS  Resume Data Extraction  Technologies : Computer Vision, Tensorflow Object Detection from pretrained model, Python3  Algorithm : Object Detection in image then applying NLP to extract structured data \nusing NER  Hindi International Phonetic Alphabet(IPA) Predictor  (OPENSPACE SERVICES)(POC) Predictive POC project which predicts  the Hindi IPA pronunciation of english words.  Technologies : NLP, Sequence2Sequence encoder decoder, Tensorflow2.0, Python3 "
  }
}'
-X POST http://compai-admin-backend.onrender.com/api/model/spacy-ner-resume

// Respuesta de ejemplo
{
  "outputs": {
    "result": {
      "Companies": [
          "Openspace Services Pvt. Ltd."
      ],
      "Designation": [
          "Python Developer - Intern",
          "Software Engineer"
      ],
      "CollegeName": [
          "Government Engineering College"
      ],
      "Education": [
          "BE Computer Science",
          "Ng (Online Coursera Stanford University)"
      ],
      "Technology": [
          "Python",
          "MySQL",
          "OpenCV",
          "Tensorflow2.0,",
          "Hugging Face NLP",
          "Tensorflow2.0",
          "Python3"
      ],
      "Certifications": [
          "Python for Data Science and AI by IBM (Online Coursera)"
      ]
    }
  }
}`
    ));

    // Pendiente
//     this.serviceItems.push(new ServiceItem(
//       10,
//       CategoryChoice.IMAGE,
//       "Detección de objetos en imágenes",
//       "Detecta objetos cotidianos como pueden ser bicicletas, sombrillas, perros, personas, etc.",
//       `Modelo DETR (Detección de objetos End-to-End) con ResNet-50 como base.

// El modelo DEtection TRansformer (DETR) model fue entrenado con el dataset para detección de objetos <i>[COCO 2017](https://paperswithcode.com/dataset/coco)</i> (118k imágenes anotadas). Fue introducido en el artículo <i>[End-to-End Object Detection with Transformers](https://arxiv.org/abs/2005.12872)</i> por <i>[Carion](https://scholar.google.com/citations?user=h8u3ll8AAAAJ&hl=en)</i>.

// Si desea explorar los tipos de objetos que puede detectar, puede remitirse a las <i>[clases del dataset de COCO](https://cocodataset.org/#explore)</i>.

// | Entrada      | Salida |
// | ----------- | ----------- |
// | <img src="../../assets/img/Bikers-840x473.jpg" width="500" height="600">      | <img src="../../assets/img/Bikers result.png" width="500" height="600">       |
// `,
//       "http://localhost:8000/api/model/detr-resnet-50",
//       3,
//       TaskType.OBJECT_DETECTION,
//       `curl
//   -X POST http://localhost:8000/api/model/detr-resnet-50
//   -H 'content-type: multipart/form-data'
//   -F file=@Bikers-840x473.jpg
//   -F token=<TOKEN>`
//     ));

    // Pendiente
//     this.serviceItems.push(new ServiceItem(
//       11,
//       CategoryChoice.IMAGE,
//       "Clasificación de imágenes con MobileNetV2",
//       "Clasifica imágenes por temática asignándole una etiqueta de un conjunto fijo de categorías.",
//       `*[MobileNetV2](https://github.com/tensorflow/models/tree/master/research/slim/nets/mobilenet)* es una mejora significativa sobre MobileNetV1 e impulsa el estado del arte para el reconocimiento visual móvil, incluida la clasificación, la detección de objetos y la segmentación semántica. MobileNetV2 se lanza como parte de la biblioteca de clasificación de imágenes *[TensorFlow-Slim](https://github.com/tensorflow/models/blob/master/research/slim/README.md)*. Alternativamente, puede descargar el *[cuaderno](https://github.com/tensorflow/models/blob/master/research/slim/nets/mobilenet/mobilenet_example.ipynb)* y explorarlo localmente usando Jupyter. MobileNetV2 también está disponible como *[módulos](https://www.tensorflow.org/hub/modules/image#mobilenet)* en TF-Hub, y los puntos de control previamente entrenados se pueden encontrar en *[GitHub](https://github.com/tensorflow/models/tree/master/research/slim/nets/mobilenet)*.

// *¿Cómo se compara con la primera generación de MobileNets?*

// En general, los modelos MobileNetV2 son más rápidos y ofrecen la misma precisión en todo el espectro de latencia. En particular, los nuevos modelos usan 2 veces menos operaciones, necesitan un 30% menos de parámetros y son entre un 30% y un 40% más rápidos en un teléfono Google Pixel que los modelos MobileNetV1, todo mientras logran una mayor precisión.

// MobileNetV2 proporciona un modelo orientado a dispositivos móviles muy eficiente que se puede utilizar como base para muchas tareas de reconocimiento visual.

// |       |  |
// | ----------- | ----------- |
// | <img src="../../assets/img/flower.jpg" width="500" height="600">      |   <img src="../../assets/img/code-img-class.png" width="500" height="600">     |
// `,
//       "http://localhost:8000/api/model/mobile-net-v2",
//       3,
//       TaskType.IMAGE_CLASS,
//       `curl
//   -X POST http://localhost:8000/api/model/mobile-net-v2
//   -H 'content-type: multipart/form-data'
//   -F file=@flower.jpg
//   -F token=<TOKEN>`
//     ));

    // Pendiente
//     this.serviceItems.push(new ServiceItem(
//       12,
//       CategoryChoice.IMAGE,
//       "Super resolución de imágenes usando ESRGAN",
//       "Mejora la calidad de las imágenes llevándolas a una resolución mayor.",
//       `*[Enhanced Super Resolution GAN](https://arxiv.org/abs/1809.00219)* para la creación de imágenes con resolución mejorada. Produce una imagen 4 veces mayor que la original, a partir de imágenes de ancho y alto superior o igual a 64 píxeles. Funciona mejor con imágenes rebajadas bicúbicamente debido a que el modelo fue entrenado con el dataset *[DIV2K](https://data.vision.ee.ethz.ch/cvl/DIV2K/)*.


// |       |  |
// | ----------- | ----------- |
// | <img src="../../assets/img/super_res_source_2.png" width="400" height="600">      |   <img src="../../assets/img/super_res_target_2.jpg" width="400" height="500">     |
// | <img src="../../assets/img/super_res_source_1.png" width="400" height="600">      |   <img src="../../assets/img/super_res_target_1.jpg" width="400" height="500">     |
// `,
//       "http://localhost:8000/api/model/esrgan-tf2",
//       3,
//       TaskType.SUPER_RESOLUTION,
//       `curl
//   -X POST http://localhost:8000/api/model/esrgan-tf2
//   -H 'content-type: multipart/form-data'
//   -F file=@monkey.png
//   -F token=<TOKEN>`
//     ));

    // Pendiente
//     this.serviceItems.push(new ServiceItem(
//       13,
//       CategoryChoice.TEXT,
//       "Reconocimiento de entidades usando bert-base",
//       "Reconoce entidades en el texto tales como Persona, Organización, Lugar, Compañías, etc.",
//       `bert-base-NER es una afinación del modelo BERT lista para ser usada para el reconocimiento de entidades. Ha sido entrenado para reconocer 4 tipos de entidades: ubicaciones (LOC), organizaciones (ORG), personas (PER) y misceláneas (MISC).

//       \nEspecíficamente, este modelo es basado en bert-base-cased, que fue afinado con la versión inglesa del dataset para *[reconocimiento de entidades CoNLL-2003](https://aclanthology.org/W03-0419.pdf)*.

//       \nLos resultados de la evaluación de este modelo son:

// | Métrica     |Desarrollo   |Prueba       |
// | :---------: | :---------: | :---------: |
// | F1          | 95.1        | 91.3        |
// | Precision   | 95.0        | 90.7        |
// | Recall      | 95.3        | 91.9        |
//       `,
//       "http://localhost:8000/api/model/bert-base-ner",
//       3,
//       TaskType.TOKEN_CLASS,
//       `curl
// -d '{
//   "token":"<TOKEN>",
//   "inputs": {
//     "text":"Pedro Rodríguez Betancourt estuvo trabajando junto a Juan Carlos Bermudez en la embajada de Bolivia en Cuba durante la toma \nde posesión del presidente."
//   }
// }'
// -X POST http://localhost:8000/api/model/bert-base-ner

// // Respuesta de ejemplo
// {
//   "outputs": {
//       "result": "Pedro: B-PER, Rodríguez: I-PER, Beta: I-PER, ##nco: I-PER, ##urt: I-PER, est: O, ##u: O, ##vo: O\nt: O, ##rab: O, ##aja: O, ##ndo: O, j: O, ##unt: O, ##o: O, a: O, Juan: B-PER, Carlos: I-PER, Be: I-PER\n##rm: I-PER, ##ude: I-PER, ##z: O, en: O, la: O, em: O, ##ba: O, ##ja: O, ##da: O, de: O, Bolivia: B-LOC\nen: O, Cuba: B-LOC, du: O, ##rant: O, ##e: O, la: O, to: O, ##ma: O, de: O, poses: O, ##ión: O, del: O\npresident: O, ##e: O, .: O, [SEP]: O",
//       "dict": {
//           "PER": [
//               "Pedro Rodríguez Betancourt",
//               "Juan Carlos Bermudez"
//           ],
//           "LOC": [
//               "Bolivia",
//               "Cuba"
//           ]
//       }
//   }
// }`
//     ));

    // Pendiente
//     this.serviceItems.push(new ServiceItem(
//       14,
//       CategoryChoice.IMAGE,
//       "Segmentación de objetos usando DETR",
//       "Segmenta una imagen en objetos como mochilas, bicicletas, personas, césped, pavimento, carros, camiones, etc.",
//       `## Modelo DETR (End-to-End Object Detection) que usa como base ResNet-101

// El modelo DEtection TRansformer (DETR) fue entrenado end-to-end con el dataset panóptico *[COCO 2017](https://cocodataset.org/#download)* que contiene 118k/5k imágenes anotadas para entrenamiento/validación respectivamente. Fue introducido en el artículo *[End-to-End Object Detection with Transformers](https://arxiv.org/abs/2005.12872)* por Carion et al.

// **Resultados de la evaluación**

// Este modelo alcanzó los siguientes resultados en la validación en *[COCO 2017](https://cocodataset.org/#download)*:

// <ul>
// <li>- Precisión promedio sobre cajas: 40.1</li>
// <li>- Precisión promedio de segmentación: 33</li>
// <li>- Calidad Panóptica: 45.1</li>
// </ul>

// | Entrada      | Salida |
// | ----------- | ----------- |
// | <img src="../../assets/img/Bikers-840x473.jpg" width="500" height="600">      | <img src="../../assets/img/segmentation_result.png" width="500" height="600">       |
// `,
//       "http://localhost:8000/api/model/detr-resnet-101-panoptic",
//       3,
//       TaskType.IMAGE_SEGMENTATION,
//       `curl
//   -X POST http://localhost:8000/api/model/detr-resnet-101-panoptic
//   -H 'content-type: multipart/form-data'
//   -F file=@Bikers-840x473.jpg
//   -F token=<TOKEN>`
//     ));

    // Pendiente
//     this.serviceItems.push(new ServiceItem(
//       15,
//       CategoryChoice.IMAGE,
//       "Clasificación de imágenes con Visual Transformers",
//       "Clasifica imágenes por temática asignándole una etiqueta de un conjunto fijo de categorías.",
//       `El modelo Vision Transformer (ViT) es un modelo codificador pre-entrenado sobre una gran colección de imágenes etiquetadas nombrada ImageNet-21k (14 millones de imágenes y 21,843 clases). Donde cada imagen tiene una resolución de 224x224 píxeles. Después del entrenamiento, el modelo fue afinado sobre la colección ImageNet (también conocida como *[ILSVRC2012](https://dbcollection.readthedocs.io/en/latest/datasets/imagenet.html)*), la cual contiene 1.2 millones de imágenes divididas en 1,000 clases, a una resolución de 384x384.

// El modelo fue presentado en el artículo *[An Image is Worth 16x16 Words: Transformers for Image Recognition at Scale](https://arxiv.org/abs/2010.11929)* por Dosovitskiy et al.

// |       |  |
// | ----------- | ----------- |
// | <img src="../../assets/img/flower.jpg" width="500" height="600">      |   <img src="../../assets/img/code-img-vit-class.png" width="500" height="600">     |
// `,
//       "http://localhost:8000/api/model/vit-base-patch32-384",
//       3,
//       TaskType.IMAGE_CLASS,
//       `curl
//   -X POST http://localhost:8000/api/model/vit-base-patch32-384
//   -H 'content-type: multipart/form-data'
//   -F file=@flower.jpg
//   -F token=<TOKEN>`
//     ));

    this.serviceItems.push(new ServiceItem(
      16,
      CategoryChoice.TEXT,
      "Generación de preguntas en Inglés",
      "Genera preguntas en base a un contexto y una respuesta escritos en Inglés.",
      `## T5-base afinado con SQuAD para la generación de preguntas

*[Google's T5](https://ai.googleblog.com/2020/02/exploring-transfer-learning-with-t5.html)* afinado con *[SQuAD v1.1](https://rajpurkar.github.io/SQuAD-explorer/)* para Generación de Preguntas especificando la respuesta al contexto.

\n<table style="width:100%">
      <tr>
        <th>&nbsp&nbsp Dataset &nbsp&nbsp</th>
        <th>&nbsp&nbsp Split &nbsp&nbsp</th>
        <th>&nbsp&nbsp No. samples &nbsp&nbsp</th>
      </tr>
      <tr>
        <td>&nbsp&nbsp &nbsp&nbsp squad</td>
        <td>&nbsp&nbsp train</td>
        <td>&nbsp&nbsp &nbsp&nbsp 87599</td>
      </tr>
      <tr>
        <td>&nbsp&nbsp &nbsp&nbsp squad</td>
        <td>&nbsp&nbsp valid</td>
        <td>&nbsp&nbsp &nbsp&nbsp 10570</td>
      </tr>
    </table>

<br/>

### **Importante**

Dado que el servicio está detenido después de un tiempo de inactividad, puede recibir diferentes respuestas
cuando es invocado estando inactivo. Estas respuestas le informaran sobre el estado en el que se encuentra,
el cual puede tomar valores como *stopped*, *pending* y *starting*.

Vea el siguiente ejemplo:
~~~json
{
  "outputs": {
    "info": "Service instance is not running yet",
    "state": "pending"
  }
}
~~~
`,
      "http://compai-admin-backend.onrender.com/api/model/question-generation",
      3,
      TaskType.QUESTION_GENERATION,
      `curl
-d '{
  "token":"<TOKEN>",
  "inputs": {
    "context":"Pisáuridos (Pisauridae) are a family of araneomorphic spiders that includes about 550 species, distributed throughout \nthe world. They live in the soil, on the surface of stagnant waters, and on aquatic plants. They are large spiders that resemble wolf \nspiders (Lycosidae) in the way they hunt and trap prey. Its carapace is oval with longitudinal markings. The females carry the ootheca \nin the chelicerae, which hang under their body. The newborn babies are placed in carp-shaped cobwebs, where they are cared for until the \nsecond shedding of skin.",
    "answer":"oval"
  }
}'
-X POST http://compai-admin-backend.onrender.com/api/model/question-generation

// Respuesta de ejemplo
{
  "outputs": {
    "result": {
      "question": "What shape is the carapace of a Pisauridos spider"
    }
  }
}`
    ));

    this.serviceItems.push(new ServiceItem(
      17,
      CategoryChoice.TEXT,
      "Generación de paráfrasis en Inglés",
      "Genera alternativas a un texto escrito en Inglés.",
      `## Genera alternativas a un texto escrito en Inglés

Parrot es un generador de paráfrasis creado con el propósito de incrementar el conjunto de entrenamiento de modelos NLU (Natural Language Understanding).

La versión que ofrecemos es una variante cuantificada del modelo original. Originalmente el modelo tiene un tamaño de 850 MB, usa una precisión basada en float32 y se construyó usando el framework Pytorch. La variante cuantificada que ofrecemos ocupa la mitad del espacio, su precisión es basada en int8 y fue obtenida después de un proceso de migración hacia Onnx.

El modelo original fue resultado de un afinamiento de un modelo base T5.

### **Importante**

Dado que el servicio está detenido después de un tiempo de inactividad, puede recibir diferentes respuestas
cuando es invocado estando inactivo. Estas respuestas le informaran sobre el estado en el que se encuentra,
el cual puede tomar valores como *stopped*, *pending* y *starting*.

Vea el siguiente ejemplo:
~~~json
{
  "outputs": {
    "info": "Service instance is not running yet",
    "state": "pending"
  }
}
~~~
`,
      "http://compai-admin-backend.onrender.com/api/model/paraphrase",
      3,
      TaskType.TEXT2TEXT_GEN,
      `curl
-X POST http://compai-admin-backend.onrender.com/api/model/paraphrase
-d '{
  "inputs": {
    "text":"The company has been providing services for 3 years when they started in a garage.",
  },
  "token": "<TOKEN>"
}'

// Respuesta de ejemplo
{
  "outputs": {
    "result": [
        "The company has been offering services for three years when they started in a garage.",
        "The company has been providing services for three years when they started in a garage.",
        "The company is a family-owned and operated company that started up in a garage for three years.",
        "The company has been bringing service services for about three years when they started in a garage.",
        "The company has provided services for 3 years when they started in a garage.",
        "The company has been providing services for 3 years when they started in a garage.",
        "The company has been in business for 3 years when they started in a garage."
    ]
  }
}`
    ));

    this.serviceItems.push(new ServiceItem(
      18,
      CategoryChoice.TEXT,
      "Reconocimiento de tecnologías en currículos en Español",
      "Reconocimiento de entidades del tipo tecnología en currículos escritos en Español.",
      `El modelo es capaz de reconocer en currículos escritos en Español, diferentes tecnologías que son mencionadas bajo el tag **Technology**.
      \nFue entrenado con 222 currículos usando como base la arquitectura ofrecida por <i>[spaCy](https://spacy.io/)</i> para la detección de entidades.
      `,
      "http://compai-admin-backend.onrender.com/api/model/spacy-ner-resume-spanish",
      3,
      TaskType.TOKEN_CLASS,
      `curl
  -d '{
  "token":"<TOKEN>",
  "inputs": {
    "text":"ESTUDIOS Universidad de las Ciencias Informáticas (UCI) / SEPT 2002 - JUN 2007 Licenciado en Ingeniería Informática Pedro \nGonzalez Gutierrez PERFIL EXPERIENCIA LABORAL Desarrollador Freelancer 1 / JUL 2012 - Desarrollador web, Desarrollador web Freelancer, \ncreación de sitios web en Wordpress, Licenciado en Complementos informáticos y temas. Ingeniero en Ciencias en 2006. Trabajando como Freelancer \nDesarrollador GIS, Creando mapas y Sistemas de Información Geográfica y Aplicaciones web Desarrollador Wordpress desde 2014. Universidad \nde las Ciencias Informáticas 3 / MAY 2007- JUNIO 2010 Líder de proyecto Desarrollador web Ciudad Sostenible, Venezuela IDIOMAS INGLÉS: \nFLUENTE ESPAÑOL: NATIVO EXPERIENCIA en_US + 10 años: 1. Sistemas de gestión de bases de datos: (MySQL, PostgreSQL, SQL Server, Firebird, \nOracle) 2. Lenguajes de programación: PHP, C ++, ActionScript, JavaScript, 3. Marcos PHP MVC: Symfony (1 y 2), CodeIgniter 2.2, CakePHP, \nAptana, Laravel 4. Frameworks de Desarrollo en JavaScript: ExtJS (versiones 3 y 4), JQuery, JQuery UI, CSS3, HTML 5 5. CMS: Wordpress, \nJoomla 6. Desarrollo de plugins y temas de Wordpress, (plugins , temas, widgets, etc.) 7. Zoho Platform PRINCIPALES PROYECTOS EN LOS \nQUE HE TRABAJADO: 1. Evaluador teórico para carnet de conducir, duración: 3 años (2004-2007), rol: Desarrollador líder. Desarrollo de \nuna aplicación de escritorio para automatizar el proceso de toma de la prueba teórica para la obtención de la licencia de conducir, utilizada \npor Comboloro en Venezuela. 2. SCADA, duración 4 meses, (septiembre 2017 a enero 2018), rol: Desarrollador, Arquitecto de Software. \nDesarrollo de una solución SCADA para implementar en las instalaciones de PDVSA utilizando software libre. 3. Supervisión energética, \nduración: 10 meses (marzo - diciembre de 2018) Rol: Desarrollador líder, Líder de proyecto. Desarrollo de una aplicación web para mostrar \nlos informes de consumo de energía y medir el efecto de las decisiones tomadas con el fin de reducir el consumo."
  }
}'
-X POST http://compai-admin-backend.onrender.com/api/model/spacy-ner-resume-spanish

// Respuesta de ejemplo
{
  "outputs": {
    "result": {
      "Technology": [
        "ActionScript",
        "C",
        "CSS3",
        "CakePHP",
        "CodeIgniter",
        "ExtJS",
        "GIS",
        "HTML",
        "JQuery",
        "JQuery UI",
        "JavaScript",
        "Joomla",
        "Laravel",
        "MVC",
        "MySQL",
        "Oracle",
        "PHP",
        "PostgreSQL",
        "SCADA",
        "SQL Server",
        "Symfony",
        "Wordpress",
        "Zoho Platform"
      ]
    }
  }
}`
    ));

    this.serviceItems.push(new ServiceItem(
      19,
      CategoryChoice.TEXT,
      "Traducción de textos",
      "Traduce textos desde el Inglés al Español usando el modelo opus-mt-en-es.",
      `
Traduce textos desde el Inglés al Español usando el modelo opus-mt-en-es.

Basado en el modelo <u>[MarianMT](https://marian-nmt.github.io/)</u>.

El modelo fue originalmente entrenado usando el dataset <u>[Open Parallel Corpus(OPUS)](http://opus.nlpl.eu/)</u> por <u>[Jörg Tiedemann](https://researchportal.helsinki.fi/en/persons/j%C3%B6rg-tiedemann)</u> usando la biblioteca de C++ Marian, la cual permite entrenamientos y traducciones rápidas.

### **Importante**

Dado que el servicio está detenido después de un tiempo de inactividad, puede recibir diferentes respuestas
cuando es invocado estando inactivo. Estas respuestas le informaran sobre el estado en el que se encuentra,
el cual puede tomar valores como *stopped*, *pending* y *starting*.

Vea el siguiente ejemplo:
~~~json
{
  "outputs": {
    "info": "Service instance is not running yet",
    "state": "pending"
  }
}
~~~`,
      "http://compai-admin-backend.onrender.com/api/model/opus-mt-en-es",
      3,
      TaskType.TRANSLATION,
      `curl
-X POST http://compai-admin-backend.onrender.com/api/model/opus-mt-en-es
-d '{
  "inputs": {
    "text": "In the world of services it is necessary for the customer to feel that it is important and to be heard. \nEveryone has their strengths."
  },
  "token": "<TOKEN>"
}'

// Respuesta de ejemplo
{
  "outputs": {
    "result": [
      {
        "translation_text": "En el mundo de los servicios es necesario que el cliente sienta que es importante y ser escuchado. \nCada uno tiene sus fortalezas."
      }
    ]
  }
}`
    ));

    this.serviceItems.push(new ServiceItem(
      20,
      CategoryChoice.TEXT,
      "Resumen de textos",
      "Resume textos desde en Inglés y Español usando el modelo MobileBERT.",
      `
      Este modelo realiza resúmenes extractivos usando como base el modelo mobilebert-uncased propuesto por Google.

      MobileBERT es una versión ligera de BERT_LARGE, diseñada cuidadosamente para encontrar un balance entre las redes feed-forward y las que utilizan autoatención.

      Comienza reduciendo las oraciones a vectores númericos, luego realiza un agrupamiento de las mismas y finalmente devuelve las oraciones más cercanas a los centroides de los grupos.
      `,
      "http://compai-admin-backend.onrender.com/api/model/summary-mobilebert-uncased",
      3,
      TaskType.SUMMARY,
      `curl
-X POST http://compai-admin-backend.onrender.com/api/model/summary-mobilebert-uncased
-d '{
  "inputs": {
    "text": "Al comenzar el espacio radiotelevisivo, Mary Blanca Ortega Barredo, jefa de la ONAT, comentó que la campaña del 2021 \nse desarrolló en un escenario complejo. Sobre él estuvo gravitando el recrudecimiento del bloqueo, agravado por los efectos de la crisis \neconómica mundial producida por la pandemia. “Todo esto ha impactado en la economía del país y, por consiguiente, en la de los \ncontribuyentes”, dijo la funcionaria. Esto llevó a mantener un grupo de medidas tributarias adoptadas desde el año anterior, \nrelacionadas con las suspensiones de algunas actividades y el aplazamiento de pagos durante varios meses del año, incluyendo la campaña \nque se aplazó hasta el 31 de mayo. Hubo una contracción de los ingresos, por lo que se aprobó en junio una modificación presupuestaria \nque fijó una recaudación de más de 245 900 millones de pesos. “Resultaba imprescindible cumplir, para asegurar y respaldar los servicios \ny programas sociales, así como todos los gastos asociados a la covid-19”, recordó la funcionaria. Señaló, además, que las oficinas de la \nONAT trabajaron casi todo el año con una reducción significativa de trabajadores, lo que tensó el cumplimiento de disímiles tareas y obligó \na continuar perfeccionando sistemas de trabajo y las vías de comunicación, información y servicios a distancia a los contribuyentes.",
    "num_sentences":2
  },
  "token": "<TOKEN>"
}'

// Respuesta de ejemplo
{
  "outputs": {
    "result": "Al comenzar el espacio radiotelevisivo, Mary Blanca Ortega Barredo, jefa de la ONAT, comentó que la campaña del 2021 \nse desarrolló en un escenario complejo. Señaló, además, que las oficinas de la ONAT trabajaron casi todo el año con una reducción \nsignificativa de trabajadores, lo que tensó el cumplimiento de disímiles tareas y obligó a continuar perfeccionando sistemas de trabajo y \nlas vías de comunicación, información y servicios a distancia a los contribuyentes."
  }
}`
    ));

    this.serviceItems.push(new ServiceItem(
      21,
      CategoryChoice.TEXT,
      "Detección de partes de una oración en Español",
      "Detecta las partes que componen una oración de idioma Español usando Spacy.",
      `
      Este servicio usa como base el modelo preentrenado de Spacy llamado 'es_core_news_sm'.

      Su conjunto de entrenamiento fue usando las fuentes [*UD Spanish AnCora v2.8*](https://github.com/UniversalDependencies/UD_Spanish-AnCora), [*WikiNER*](https://figshare.com/articles/Learning_multilingual_named_entity_recognition_from_Wikipedia/5462500) y [*spaCy lookups data*](https://github.com/explosion/spacy-lookups-data).

      La precisión alcanzada detectando correctamente las partes de una oración es de 0.98.
      `,
      "http://compai-admin-backend.onrender.com/api/model/spacy-pos-es",
      3,
      TaskType.TOKEN_CLASS,
      `curl
-X POST http://compai-admin-backend.onrender.com/api/model/spacy-pos-es
-d '{
  "inputs": {
    "text": "Juan va a Italia la semana próxima."
  },
  "token": "<TOKEN>"
}'

// Respuesta de ejemplo
{
  "outputs": {
    "result": [
      [ "Juan", "Juan", "PROPN", "PROPN" ],
      [ "va", "ir", "VERB", "VERB" ],
      [ "a", "a", "ADP", "ADP" ],
      [ "Italia", "Italia", "PROPN", "PROPN" ],
      [ "la", "el", "DET", "DET" ],
      [ "semana", "semana", "NOUN", "NOUN" ],
      [ "próxima", "próximo", "ADJ", "ADJ" ],
      [ ".", ".", "PUNCT", "PUNCT" ]
    ]
  }
}`
    ));

    this.serviceItems.push(new ServiceItem(
      22,
      CategoryChoice.TEXT,
      "Detección de partes de una oración en Inglés",
      "Detecta las partes que componen una oración de idioma Inglés usando Spacy.",
      `
      Este servicio usa como base el modelo preentrenado de Spacy llamado *en_core_web_sm*.

      Su conjunto de entrenamiento fue usando las fuentes [*OntoNotes 5*](https://catalog.ldc.upenn.edu/LDC2013T19), [*ClearNLP Constituent-to-Dependency Conversion*](https://github.com/clir/clearnlp-guidelines/blob/master/md/components/dependency_conversion.md) y [*WordNet 3.0*](https://wordnet.princeton.edu/).

      La precisión alcanzada detectando correctamente las partes de una oración es de 0.97.
      `,
      "http://compai-admin-backend.onrender.com/api/model/spacy-pos-en",
      3,
      TaskType.TOKEN_CLASS,
      `curl
-X POST http://compai-admin-backend.onrender.com/api/model/spacy-pos-en
-d '{
  "inputs": {
    "text": "Juan will go to Italy next week."
  },
  "token": "<TOKEN>"
}'

// Respuesta de ejemplo
{
  "outputs": {
    "result": [
      [ "Juan", "Juan", "PROPN", "NNP" ],
      [ "will", "will", "AUX", "MD" ],
      [ "go", "go", "VERB", "VB" ],
      [ "to", "to", "ADP", "IN" ],
      [ "Italy", "Italy", "PROPN", "NNP" ],
      [ "next", "next", "ADJ", "JJ" ],
      [ "week", "week", "NOUN", "NN" ],
      [ ".", ".", "PUNCT", "." ]
    ]
  }
}`
    ));

    this.serviceItems.push(new ServiceItem(
      23,
      CategoryChoice.TEXT,
      "Detección de entidades de un texto en Inglés",
      "Detecta las entidades presentes en un texto de idioma Inglés usando Spacy.",
      `
      Este servicio usa como base el modelo preentrenado de Spacy llamado *en_core_web_sm*.

      Su conjunto de entrenamiento fue usando las fuentes [*OntoNotes 5*](https://catalog.ldc.upenn.edu/LDC2013T19), [*ClearNLP Constituent-to-Dependency Conversion*](https://github.com/clir/clearnlp-guidelines/blob/master/md/components/dependency_conversion.md) y [*WordNet 3.0*](https://wordnet.princeton.edu/).

      Las entidades que detecta son: CARDINAL, DATE, EVENT, FAC, GPE, LANGUAGE, LAW, LOC, MONEY, NORP, ORDINAL, ORG, PERCENT, PERSON, PRODUCT, QUANTITY, TIME, WORK_OF_ART.

      <table>
      <tr>
        <th>Atributo&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp</th>
        <th>Valor</th>
      </tr>
      <tr>
        <td>precision</td>
        <td>0.85</td>
      </tr>
      <tr>
        <td>recall</td>
        <td>0.84</td>
      </tr>
      <tr>
        <td>F-score</td>
        <td>0.84</td>
      </tr>
      </table>
      `,
      "http://compai-admin-backend.onrender.com/api/model/spacy-ner-en",
      3,
      TaskType.TOKEN_CLASS,
      `curl
-X POST http://compai-admin-backend.onrender.com/api/model/spacy-ner-en
-d '{
  "inputs": {
    "text": "Juan will go to Italy next week."
  },
  "token": "<TOKEN>"
}'

// Respuesta de ejemplo
{
  "outputs": {
    "result": {
        "PER": [
            "Juan"
        ],
        "LOC": [
            "Italy"
        ]
    }
  }
}`
    ));

    this.serviceItems.push(new ServiceItem(
      24,
      CategoryChoice.TEXT,
      "Detección de entidades de un texto en Español",
      "Detecta las entidades presentes en un texto de idioma Español usando Spacy.",
      `
      Este servicio usa como base el modelo preentrenado de Spacy llamado 'es_core_news_sm'.

      Su conjunto de entrenamiento fue usando las fuentes [*UD Spanish AnCora v2.8*](https://github.com/UniversalDependencies/UD_Spanish-AnCora), [*WikiNER*](https://figshare.com/articles/Learning_multilingual_named_entity_recognition_from_Wikipedia/5462500) y [*spaCy lookups data*](https://github.com/explosion/spacy-lookups-data).

      Las entidades que detecta son: LOC, MISC, ORG, PER.

      <table>
      <tr>
        <th>Atributo&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp</th>
        <th>Valor</th>
      </tr>
      <tr>
        <td>precision</td>
        <td>0.89</td>
      </tr>
      <tr>
        <td>recall</td>
        <td>0.89</td>
      </tr>
      <tr>
        <td>F-score</td>
        <td>0.89</td>
      </tr>
      </table>
      `,
      "http://compai-admin-backend.onrender.com/api/model/spacy-ner-es",
      3,
      TaskType.TOKEN_CLASS,
      `curl
-X POST http://compai-admin-backend.onrender.com/api/model/spacy-ner-es
-d '{
  "inputs": {
    "text": "Juan va a Italia la semana próxima."
  },
  "token": "<TOKEN>"
}'

// Respuesta de ejemplo
{
  "outputs": {
    "result": {
        "PER": [
            "Juan"
        ],
        "LOC": [
            "Italia"
        ]
    }
  }
}`
    ));

    this.serviceItems.push(new ServiceItem(
      25,
      CategoryChoice.TEXT,
      "Análisis de sentimiento de un texto en Español",
      "Obtiene un valor que representa que tan positivo es el texto.",
      `
      Este modelo es el resultado del afinamiento de un modelo con arquitectura [*ELECTRA*](https://openreview.net/pdf?id=r1xMH1BtvB) en su versión 'small'.

      El mismo fue entrenado con un conjunto de datos que contiene opiniones de clientes de restaurantes.

      El nivel de precisión alcanzado sobre el subconjunto de pruebas fue de 0.86.
      `,
      "http://compai-admin-backend.onrender.com/api/model/electra-sentiment",
      3,
      TaskType.TEXT_CLASS,
      `curl
-X POST http://compai-admin-backend.onrender.com/api/model/electra-sentiment
-d '{
  "inputs": {
    "text": "La película que proyectaron no fue del agrado de María."
  },
  "token": "<TOKEN>"
}'

// Respuesta de ejemplo
{
  "outputs": {
      "result": {
          "label": "negative",
          "score": 0.7282810807228088
      }
  }
}`
    ));

    this.serviceItems.push(new ServiceItem(
      26,
      CategoryChoice.TEXT,
      "Clasificación dinámica de un texto en Español usando ELECTRA",
      "Clasifica un texto atendiendo a las categorías provistas dinámicamente.",
      `
      Este modelo es el resultado del afinamiento de un modelo con arquitectura [*ELECTRA*](https://openreview.net/pdf?id=r1xMH1BtvB) en su versión 'small'.
      `,
      "http://compai-admin-backend.onrender.com/api/model/electricidad-small-finetuned-xnli-es",
      3,
      TaskType.ZERO_SHOT_CLASS,
      `curl
-X POST http://compai-admin-backend.onrender.com/api/model/electricidad-small-finetuned-xnli-es
-d '{
  "inputs": {
    "text":"Los peloteros hicieron un buen desempeño durante la temporada",
    "candidates":["cultura", "política", "deporte", "ciencia"]
  },
  "token": "<TOKEN>"
}'

// Respuesta de ejemplo
{
  "outputs": {
      "result": {
        "sequence": "Los peloteros hicieron un buen desempeño durante la temporada",
        "labels": [ "deporte", "cultura", "política", "ciencia" ],
        "scores": [
            0.32442227005958557,
            0.2802445888519287,
            0.2176978588104248,
            0.17763522267341614
        ]
    }
  }
}`
    ));

    for (const item of this.serviceItems) {
      item.status = item.deploymentStatus()
    }
  }

  getAll(): ServiceItem[] {
    return this.serviceItems;
  }

  getById(id: number) {
    return this.serviceItems.find(x => x.id === id);
  }
}
